import ListadoAmigos from './ListadoAmigos'

export default ListadoAmigos
